export default "__VITE_ASSET__ee69526c__"